import CustomTriggerProvider from './CustomTriggerProvider';

export default CustomTriggerProvider;
